import dedent from 'ts-dedent'
import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  QueryAndOutputs,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { addColumn } from '../utils/schemas'
import { SingleOutputWorkflowComponent } from './common/singleoutputcomponent'

class H3Center extends SingleOutputWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.h3center',
        group: 'Spatial Indexes',
        title: 'H3 Center',
        description: `
      This component adds a new column containing the centers of H3 cells.
      `,
        starred: true
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'h3col',
          type: WorkflowComponentParamType.Column,
          title: 'H3 column',
          parent: 'source',
          placeholder: 'h3',
          dataType: [ColumnDataType.String]
        }
      ]
    )
  }

  async getCode({
    workflow,
    params,
    connection,
    envVars,
    componentName,
    codeType
  }: WorkflowComponentCodeParams): Promise<QueryAndOutputs | null> {
    const outputTablename = connection.getOutputTableName(workflow.id, componentName, params, 'result', codeType)
    const preparedParams = this._prepareParameters(params)
    const at = connection.quoteName(envVars.analyticsToolboxDataset as string)
    let select = ''
    if (connection.type === Provider.DatabricksRest) {
      select = dedent`
        SELECT /*+ REPARTITION(40, ${preparedParams.h3col}_geom) */
          *,
          H3_CENTERASWKB(
            ${preparedParams.h3col}
          ) AS ${preparedParams.h3col}_geom
        FROM
          ${connection.quoteName(preparedParams.source as string)}`
    } else {
      select = dedent`
        SELECT
          *,
          ${at}.H3_CENTER(
            ${preparedParams.h3col}
          ) AS ${preparedParams.h3col}_geom
        FROM
          ${connection.quoteName(preparedParams.source as string)}`
    }
    let query = connection.getCreateTempTableQuery(outputTablename, select, codeType, null)
    if (connection.type === Provider.Postgres) {
      query = dedent`IF EXISTS(SELECT 1 FROM pg_extension WHERE extname = 'plv8') THEN
                          ${query}
                        ELSE
                          RAISE EXCEPTION 'plv8 extension not installed';
                        END IF;`
    }

    return {
      query,
      outputs: { result: outputTablename }
    }
  }

  requiredAnalyticsToolboxVersion(provider: Provider): string | null {
    switch (provider) {
      case Provider.Snowflake:
        return '1.2.0'
      case Provider.Postgres:
        return '1.1.1'
      default:
        return '1.0.0'
    }
  }

  getVersion(provider: Provider) {
    return '1.1'
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ columns, params, connection }: GetOutputSchemaParams): TableSchema {
    return addColumn(columns.source, {
      name: `${params.h3col}_geom`,
      type: connection.getGeoDataType()
    })
  }
  supportedProviders(): Provider[] {
    return [Provider.BigQuery, Provider.Snowflake, Provider.Postgres, Provider.DatabricksRest]
  }
}

export { H3Center }
